"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatBillingDate = formatBillingDate;
exports.formatMoney = formatMoney;
function formatMoney(amount, currency) {
    return new Intl.NumberFormat("en-ZA", { style: "currency", currency: currency }).format(amount);
}
function formatBillingDate(isoDate) {
    return new Date(isoDate).toLocaleDateString("en-ZA", { dateStyle: "medium" });
}
